import React, { Component } from "react";
import classnames from "classnames";
import { connect } from "react-redux";
import {
  closeModal,
} from "redux/actions/global";
import { t } from "utils";

class LivesearchStepByStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
      totalSteps: 2,
    };
  }
  componentDidMount() {
    // Si ya fue visto (guardado en localStorage), cerrar el modal automáticamente
    const hasSeenLivesearchStepByStep = localStorage.getItem('livesearchStepByStep_seen') === 'true';
    if (hasSeenLivesearchStepByStep) {
      this.handleFinish();
      return;
    }
    
    // Agregar clase al body cuando estemos en el primer paso
    if (this.state.currentStep === 1) {
      document.body.classList.add('livesearch-step-1-active');
      // Hacer scroll al 6to elemento y posicionar el modal arriba de él
      this.scrollToSixthElement();
    }
  }

  getTargetArticle = () => {
    return document.querySelector('#onboarding-article-6, #onboarding-article-1');
  }

  scrollToSixthElement = () => {
    // Ocultar el modal con transición suave
    const modal = document.querySelector('.livesearch-step-by-step');
    if (modal) {
      modal.style.transition = 'opacity 0.3s ease-out';
      modal.style.opacity = '0';
    }

    // Esperar a que termine el fade out antes de hacer el scroll
    setTimeout(() => {
      const sixthItem = this.getTargetArticle();
      if (sixthItem) {
        // Calcular posición del elemento
        const rect = sixthItem.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const modalHeight = 200; // Altura aproximada del modal
        // Scroll para que el artículo quede visible con espacio para el modal arriba
        const targetPosition = rect.top + scrollTop - modalHeight - 50;
        
        // Hacer scroll suave
        window.scrollTo({
          top: Math.max(0, targetPosition),
          behavior: 'smooth'
        });

        // Actualizar la posición del modal después del scroll y mostrarlo con fade in
        setTimeout(() => {
          this.updateModalPosition();
          // Mostrar el modal con transición suave
          const modalAfter = document.querySelector('.livesearch-step-by-step');
          if (modalAfter) {
            modalAfter.style.transition = 'opacity 0.4s ease-in';
            modalAfter.style.opacity = '1';
          }
        }, 800);
      }
    }, 350);
  }

  updateModalPosition = () => {
    const sixthItem = this.getTargetArticle();
    const modal = document.querySelector('.livesearch-step-by-step');
    if (sixthItem && modal) {
      const rect = sixthItem.getBoundingClientRect();
      const modalHeight = modal.offsetHeight;
      // Posicionar el modal 10px arriba del elemento
      const topPosition = rect.top - modalHeight - 10;
      
      // Posicionar el modal arriba del 6to elemento (position fixed para que sea relativo al viewport)
      modal.style.position = 'fixed';
      modal.style.top = `${Math.max(36, topPosition)}px`;
      modal.style.left = '44%';
      modal.style.transform = 'translateX(-50%)';
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Actualizar clase del body cuando cambie el paso
    if (prevState.currentStep !== this.state.currentStep) {
      if (this.state.currentStep === 1) {
        document.body.classList.add('livesearch-step-1-active');
        document.body.classList.remove('livesearch-step-2-active');
        this.scrollToSixthElement();
      } else if (this.state.currentStep === 2) {
        document.body.classList.remove('livesearch-step-1-active');
        document.body.classList.add('livesearch-step-2-active');
        this.scrollToSelectedBar();
      }
    }
  }

  componentWillUnmount() {
    // Remover clases del body cuando se desmonte el componente
    document.body.classList.remove('livesearch-step-1-active');
    document.body.classList.remove('livesearch-step-2-active');
  }

  scrollToSelectedBar = () => {
    // Ocultar el modal con transición suave
    const modal = document.querySelector('.livesearch-step-by-step');
    if (modal) {
      modal.style.transition = 'opacity 0.3s ease-out';
      modal.style.opacity = '0';
    }

    // Esperar a que termine el fade out antes de hacer el scroll
    setTimeout(() => {
      const selectedBar = document.getElementById('onboarding-selected-bar');
      if (selectedBar) {
        // Hacer scroll suave al inicio de la página para ver la barra
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });

        // Posicionar el modal después del scroll y mostrarlo con fade in
        setTimeout(() => {
          this.updateModalPositionForSelectedBar();
          // Mostrar el modal con transición suave
          const modalAfter = document.querySelector('.livesearch-step-by-step');
          if (modalAfter) {
            modalAfter.style.transition = 'opacity 0.4s ease-in';
            modalAfter.style.opacity = '1';
          }
        }, 800);
      }
    }, 350);
  }

  updateModalPositionForSelectedBar = () => {
    const selectedBar = document.getElementById('onboarding-selected-bar');
    const modal = document.querySelector('.livesearch-step-by-step');
    if (selectedBar && modal) {
      const rect = selectedBar.getBoundingClientRect();
      // Posicionar el modal 10px debajo de la barra, alineado a la izquierda
      const topPosition = rect.bottom + 10;
      const leftPosition = rect.left;
      
      modal.style.position = 'fixed';
      modal.style.top = `${topPosition}px`;
      modal.style.left = `${leftPosition}px`;
      modal.style.transform = 'none';
    }
  }


  handleNext = () => {
    const { currentStep, totalSteps } = this.state;
    if (currentStep < totalSteps) {
      this.setState({ currentStep: currentStep + 1 });
    } else {
      this.handleFinish();
    }
  }

  handlePrevious = () => {
    const { currentStep } = this.state;
    if (currentStep > 1) {
      this.setState({ currentStep: currentStep - 1 });
    }
  }

  handleFinish = () => {
    // Marcar como visto en localStorage
    localStorage.setItem('livesearchStepByStep_seen', 'true');
    this.props.closeModal();
    if (typeof this.props.onClose === "function") {
      this.props.onClose();
    }
  }

  handleSkip = () => {
    this.handleFinish();
  }

  render() {
    const { currentStep, totalSteps } = this.state;
    const isFirstStep = currentStep === 1;
    const isLastStep = currentStep === totalSteps;
    
    // Si ya fue visto (guardado en localStorage), no renderizar nada
    const hasSeenLivesearchStepByStep = localStorage.getItem('livesearchStepByStep_seen') === 'true';
    if (hasSeenLivesearchStepByStep) {
      return null;
    }

    return (
      <div
        tabIndex="1"
        className={classnames(
          "modal-content",
          "livesearch-step-by-step-wrapper",
          { "step-1": isFirstStep }
        )}>
        <div className="livesearch-step-by-step">
          <div className="livesearch-step-by-step-content">
            <div className="step-overlay">
              <div className="step-title">{t(`livesearch_step_by_step.step${currentStep}.title`)}</div>
              <div className="step-description">{t(`livesearch_step_by_step.step${currentStep}.description`)}</div>

              <div className="step-navigation">
                <div className="step-indicator">
                  {currentStep} {t('livesearch_step_by_step.of')} {totalSteps}
                </div>

                <div className="step-buttons">
                  <button
                    className="btn btn-secondary"
                    onClick={this.handlePrevious}
                    disabled={isFirstStep}>
                    {t('livesearch_step_by_step.previous')}
                  </button>

                  <button
                    className="btn btn-primary"
                    onClick={isLastStep ? this.handleFinish : this.handleNext}>
                    {isLastStep ? t('livesearch_step_by_step.finish') : t('livesearch_step_by_step.next')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const actions = {
  closeModal,
};

export default connect(mapStateToProps, actions)(LivesearchStepByStep);
